import React, { useContext } from "react";
import styled from "styled-components";
import { space, layout } from "styled-system";
import { ThemeContext } from "styled-components";

import StyledIcon from "../Interfaces/StyledIcon";

const StyledContainer = styled.div<StyledIcon>`
  display: inline-block;
  ${space}
  ${layout}
`;

const BookSVG: React.FunctionComponent<StyledIcon> = (props) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors["primary-navy-blue"] || "primary-navy-blue";
  return (
    <StyledContainer {...props} color="black">
      <title>Book Icon</title>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="book"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          fill={hexColor}
          d="M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
        ></path>
      </svg>
    </StyledContainer>
  );
};

export default BookSVG;
